import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * PasswordInput — input password con toggle visibilità (icona occhio).
 *
 * Utilizzo:
 *   <PasswordInput
 *     data-testid="login-password"
 *     value={password}
 *     onChange={e => setPassword(e.target.value)}
 *     required
 *     minLength={6}
 *     autoComplete="current-password"
 *   />
 *
 * L'icona è posizionata assolutamente all'interno del wrapper.
 * `containerClassName` sovrascrive il wrapper esterno (default: full-width).
 * Tutte le altre prop vengono forwardate all'`<input>`.
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", containerClassName = "", visibilityTestIdSuffix = "toggle-visibility", ...props },
  ref,
) {
  const [visible, setVisible] = useState(false);
  const testId = props["data-testid"];
  const toggleTestId = testId ? `${testId}-${visibilityTestIdSuffix}` : undefined;

  return (
    <div className={`relative ${containerClassName || "w-full"}`}>
      <input
        {...props}
        ref={ref}
        type={visible ? "text" : "password"}
        className={`${className} pr-11`}
      />
      <button
        type="button"
        data-testid={toggleTestId}
        aria-label={visible ? "Nascondi password" : "Mostra password"}
        aria-pressed={visible}
        onClick={() => setVisible(v => !v)}
        tabIndex={-1}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-primary transition-colors p-1 rounded-full focus:outline-none focus:ring-2 focus:ring-primary/30"
      >
        {visible ? (
          <EyeOff className="w-4 h-4" strokeWidth={1.6} />
        ) : (
          <Eye className="w-4 h-4" strokeWidth={1.6} />
        )}
      </button>
    </div>
  );
});

export default PasswordInput;
export { PasswordInput };
